import { lazy } from 'react';

/** Authorized Pages */

export const Ingestion = lazy(() => import('./Authorized/Pipelines'));
export const NewPipeline = lazy(() =>
  import('./Authorized/Pipelines/NewPipeline')
);
export const PipelineDetails = lazy(() =>
  import('./Authorized/Pipelines/PipelineDetails')
);
export const Visualization = lazy(() => import('./Authorized/Visualization'));
export const ManageUsers = lazy(() => import('./Authorized/Management/Users'));
export const Transformation = lazy(() => import('./Authorized/Transformation'));
export const TransformationDetails = lazy(() =>
  import('./Authorized/Transformation/TransformationDetails')
);
export const Infrastructure = lazy(() => import('./Authorized/Infrastructure'));
export const Sandbox = lazy(() => import('./Authorized/Sandbox'));
export const Addons = lazy(() => import('./Authorized/Addons'));
// export const AddonDetails = lazy(() => import('./Authorized/Addons/Details'));

/** Unauthorized Pages */
export const Login = lazy(() => import('./Unauthorized/Login'));
export const Register = lazy(() => import('./Unauthorized/Register'));
export const Callback = lazy(() => import('./Unauthorized/Callback'));
export const Invite = lazy(() => import('./Unauthorized/Invite'));
